<nav>
    <ul [class.hide-cart-text]="(showContact$ | async) && showCoursesOverview && (showCart$ | async)">
        <li>
            <a
                da-link
                routerLinkActive="active-link"
                [routerLink]="linkCourseOverview"
                [innerHTML]="'navigation.eLearningCourses' | translate"
                >eLearning Courses</a
            >
        </li>
        <li *ngIf="showTrainingAdvisor && site === 'de_de'">
            <a
                da-link
                routerLinkActive="active-link"
                [routerLink]="linkTrainingAdvisor"
                [innerHTML]="'navigation.trainingAdvisor' | translate"
                ></a
            >
        </li>
        <!-- <li *ngIf="showSearch$ | async">
            <a da-link routerLinkActive="active-link" [routerLink]="'/search' | localize" [innerHTML]="'navigation.search' | translate"
                >Search</a
            >
        </li> -->
        <li *ngIf="showContact$ | async">
            <a da-link routerLinkActive="active-link" [routerLink]="linkContact" [innerHTML]="'navigation.contactUs' | translate"
                >Contact us</a
            >
        </li>
        <li *ngIf="showCart$ | async">
            <a da-link routerLinkActive="active-link" class="cart-link" [routerLink]="linkCheckout"
                ><span [innerHTML]="'navigation.cart' | translate"></span> </a
            ><da-cart></da-cart>
        </li>
    </ul>
</nav>
